import { trackGallery } from 'apps/variants/track_events';
trackGallery();
